// material-ui
import { styled } from "@mui/material/styles";
import Drawer from "@mui/material/Drawer";

// project-imports
import {
  DRAWER_WIDTH,
  MINI_DRAWER_WIDTH,
  DRAWER_SLOT_WIDTH,
  MINI_DRAWER_SLOT_WIDTH,
} from "config";
import { drawerPaperInsetSx, V2 } from "./drawerV2Tokens";

const paperInset = {
  ...drawerPaperInsetSx,
  position: "fixed",
};

const openedMixin = (theme) => ({
  width: DRAWER_SLOT_WIDTH,
  transition: theme.transitions.create(["width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
  border: "none",
  background: "transparent",
});

const closedMixin = (theme) => ({
  width: MINI_DRAWER_SLOT_WIDTH,
  transition: theme.transitions.create(["width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  border: "none",
  background: "transparent",
});

const openedPaperMixin = (theme) => ({
  ...paperInset,
  width: DRAWER_WIDTH,
  transition: theme.transitions.create(["width", "top", "height"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedPaperMixin = (theme) => ({
  ...paperInset,
  width: MINI_DRAWER_WIDTH,
  transition: theme.transitions.create(["width", "top", "height"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
});

// ==============================|| DRAWER - MINI STYLED ||============================== //

const MiniDrawerStyled = styled(Drawer, {
  shouldForwardProp: (prop) => prop !== "open" && prop !== "isAdmin",
})(({ theme, open }) => ({
  width: open ? DRAWER_SLOT_WIDTH : MINI_DRAWER_SLOT_WIDTH,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  fontFamily: V2.fontBody,
  // Reserve left gutter in the layout flow (paper itself is inset)
  marginLeft: 0,
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedPaperMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedPaperMixin(theme),
  }),
}));

export default MiniDrawerStyled;
